<template>
  <div v-loading.body="loading">
    <el-row style="height: 30px; border-bottom: 1px solid #ddd">
      <el-col :span="24">
        {{ $route.query.id ? "修改" : "新建" }}计划外代采单
      </el-col>
    </el-row>
    <el-row style="height: 50px" type="flex" justify="center">
      <el-col>
        <el-form
          :inline="true"
          style="width: 1200px !important"
          :model="form"
          class="demo-form-inline"
        >
          <el-form-item label="商家">
            <el-select
              v-model="supply_id"
              :remote-method="fetchSupply"
              remote
              filterable
            >
              <el-option
                v-for="item in supplyOption"
                :key="item.supply_id"
                :value="item.supply_id"
                :label="item.supply_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-select
            v-model="form.cg_type"
            label="支付情况"
            style="width: 150px"
            placeholder="选择支付情况"
          >
            <el-option
              v-for="item in cgtypeOptions"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
          <el-form-item>
            <el-input
              v-model.trim="form.prepay_people"
              style="width: 150px"
              placeholder="垫付人"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div style="height: 150px">
      <el-row style="height: 60px" type="flex" justify="center">
        <el-col :span="24" :style="'width:100%;'">
          <el-upload
            :style="'width:100px;float:left;height:50px;'"
            class="upload-demo"
            :show-file-list="false"
            :action="action"
            style="display: inline-block; margin-right: 10px"
            multiple
            accept="image/*"
            :on-success="uploadSuccess1"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            :limit="9"
            :on-exceed="handleExceed"
            :file-list="files"
            with-credentials
          >
            <el-button size="small" style="margin: 10px 3px" type="primary">
              上传开单单据</el-button
            >
          </el-upload>
          <template v-if="images1.length > 0">
            <div
              v-for="item in images1"
              :key="item"
              style="
                float: left;
                width: 50px;
                height: 50px;
                margin: 0 10px;
                border: 1px solid #ddd;
              "
            >
              <div style="position: relative">
                <img
                  style="width: 50px; height: 50px"
                  :src="item"
                  @click="previewImage(item)"
                />
                <div
                  style="
                    width: 15px;
                    height: 15px;
                    position: absolute;
                    top: -5px;
                    right: -5px;
                  "
                  @click="deleteImg1(item)"
                >
                  <img
                    style="width: 15px; height: 15px"
                    :src="origin + '/201804/13/15235857625ad012e238658.png'"
                  />
                </div>
              </div>
            </div>
          </template>
        </el-col>
      </el-row>

      <el-row>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-row>
      <el-row style="height: 60px" type="flex" justify="center">
        <el-col :span="24" :style="'width:100%;'">
          <el-upload
            :style="'width:100px;float:left;'"
            class="upload-demo"
            :show-file-list="false"
            :action="action"
            style="display: inline-block; margin-right: 10px"
            multiple
            accept="image/*"
            :on-success="uploadSuccess2"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            :limit="9"
            :on-exceed="handleExceed"
            :file-list="files"
            with-credentials
          >
            <el-button size="small" style="margin: 10px 3px" type="primary">
              上传付款回执</el-button
            >
          </el-upload>
          <template v-if="images2.length > 0">
            <div
              v-for="item in images2"
              :key="item"
              style="
                float: left;
                width: 50px;
                height: 50px;
                margin: 0 10px;
                border: 1px solid #ddd;
              "
            >
              <div style="position: relative">
                <img
                  style="width: 50px; height: 50px"
                  :src="item"
                  @click="previewImage(item)"
                />
                <div
                  style="
                    width: 15px;
                    height: 15px;
                    position: absolute;
                    top: -5px;
                    right: -5px;
                  "
                  @click="deleteImg2(item)"
                >
                  <img
                    style="width: 15px; height: 15px"
                    :src="origin + '/201804/13/15235857625ad012e238658.png'"
                  />
                </div>
              </div>
            </div>
          </template>
        </el-col>
      </el-row>
    </div>
    <div style="padding-bottom: auto">
      <el-row>
        <div>
          <div
            style="height: 40px; padding-left: 15px; padding-top: 10px"
            class="card-title"
          >
            商品信息
            <el-button
              style="margin-left: 94%; position: relative; top: -30px"
              type="primary"
              size="small"
              @click="selectGoods"
              >选择商品</el-button
            >
          </div>
        </div>
        <el-col style="border: 1px solid #ddd">
          <el-table
            v-if="goodsList"
            ref="multipleTable"
            height="700"
            tooltip-effect="dark"
            :data="goodsList"
          >
            <el-table-column
              label="序号"
              type="index"
              align="center"
            ></el-table-column>
            <el-table-column align="center" prop="goods_img" label="商品图片">
              <template slot-scope="scope">
                <div>
                  <img
                    style="width: 50px; height: 50px"
                    :src="scope.row.goods_img"
                    @click="previewImage(scope.row.goods_img)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="goods_name"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_no"
              label="货号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="brand_name"
              label="品牌"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pg_name"
              label="买手组"
            ></el-table-column>
            <el-table-column align="center" label="颜色">
              <template slot-scope="scope">
                <div>
                  <el-select
                    v-if="scope.row.colval_ary.length > 0"
                    v-model="scope.row.co_val"
                    label="颜色"
                    placeholder="颜色"
                    @change="getSizeArr(scope.row)"
                  >
                    <el-option
                      v-for="(item, index) in scope.row.colval_ary"
                      :key="index"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="尺码">
              <template v-if="scope.row" slot-scope="scope">
                <div>
                  <el-select
                    v-model="scope.row.si_val"
                    label="尺码"
                    placeholder="尺码"
                  >
                    <el-option
                      v-for="(item, index) in scope.row.sizeval_ary"
                      :key="index"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="数量">
              <template v-if="scope.row" slot-scope="scope">
                <div>
                  <el-input-number
                    v-model="scope.row.num"
                    style="width: 100px"
                    size="small"
                    :min="1"
                    :max="10000"
                    label="数量"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="price" label="代采价" align="center">
              <template slot-scope="scope">
                <input
                  v-model="scope.row.price"
                  type="text"
                  style="
                    width: 100%;
                    text-align: center;
                    font-size: 14px;
                    border: 0;
                  "
                  :style="{
                    color:
                      Number(scope.row.price) == Number(scope.row.market_price)
                        ? '#606266'
                        : '#FF4040',
                  }"
                />
              </template>
            </el-table-column>
            <el-table-column align="center" prop="sum_price" label="小计">
              <template slot-scope="scope">
                {{ (scope.row.num * scope.row.price).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <div>
                  <img
                    :src="origin + '/201804/13/15236013235ad04fab6c278.png'"
                    style="margin-left: -10px; width: 40px; height: 40px"
                    @click="addGoods(scope.row)"
                  />
                  <img
                    :src="origin + '/201804/13/15236017165ad05134347d8.png'"
                    style="
                      margin-left: 10px;
                      margin-bottom: 5px;
                      width: 30px;
                      height: 30px;
                    "
                    @click="delGoods(scope.row)"
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <div
          style="
            text-align: right;
            height: 40px;
            background: rgba(177, 177, 177, 23%);
            line-height: 40px;
            padding: 0 40px;
            font-size: 14px;
            color: #ff4040;
          "
        >
          合计数量：{{ figureNum }}件 合计金额： ¥{{ figureAllAmount }}
        </div>
      </el-row>
    </div>

    <el-row>
      <div>
        <div style="margin-top: 20px">
          <div class="card-title">金额信息</div>
        </div>
        <el-table border style="width: 100%" :data="tableFigure">
          <el-table-column label="代采金额" align="center">
            <template slot-scope="{}">
              <div>{{ figureAllAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="实付金额" align="center">
            <template slot-scope="{}">
              <div>{{ figureRealAmount }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>

    <div>
      <div style="padding-bottom: 300px">
        <div class="card-title">代采备注</div>
        <el-input
          v-model.trim="note"
          type="textarea"
          :rows="8"
          :placeholder="note || '请输入内容'"
        ></el-input>
        <div style="text-align: right; margin-top: 20px">
          <el-button type="primary" size="small" @click="submit">
            提交</el-button
          >
          <el-button size="small" type="danger" @click="$router.go(-1)">
            取消</el-button
          >
        </div>
      </div>
    </div>

    <div v-if="dialogTableVisible">
      <el-dialog
        选择产品
        :visible.sync="dialogTableVisible"
        width="80%"
        style="margin-top: -6vh"
        @open="handleOpen"
        @close="handleClose"
      >
        <SelectGoods
          ref="child"
          :supply_id="supply_id"
          @verifyAddSelectGoods="addSelectGoods"
          @digclose="digclose"
        ></SelectGoods>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import SelectGoods from "./SelectGoodsList.vue";
import Global_ from "../components/Global";
import apiBaseURL from "@/utils/baseUrl.js";

let fromPath = "";
export default {
  name: "Purchaseorderedit",
  components: {
    SelectGoods,
  },
  beforeRouteEnter(to, from, next) {
    fromPath = from.name;
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      origin: Global_.origin,
      cgtypeOptions: [
        {
          value: "1",
          label: "计划外-未垫付",
        },
        {
          value: "2",
          label: "计划外-已垫付",
        },
      ],
      value: "",
      size_ary: [],
      supply_id: "",
      supplyOption: [],
      form: {
        cg_type: "",
      },
      info: null,
      logs: null,
      note: "",
      loading: false,
      files: [],
      index_num: 0,
      pickerGroup: "",
      purchaseGroup: "",
      supplyName: "",
      prepay_people: "",
      orderData: "",
      images1: [],
      images2: [],
      dialogImageUrl: "",
      dialogVisible: false,
      colval_ary: [],
      temp: [],
      goodsList: [],
      dialogTableVisible: false,
      searchCondition: [],
      // 嵌套商品页面参数
      tableFigure: [{ realamount: 0 }],
      disableFlag: false,
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
    // 合计数量
    figureNum() {
      let num = 0;
      if (this.goodsList !== undefined && this.goodsList !== null) {
        for (const i in this.goodsList) {
          num += this.goodsList[i].num;
        }
      }
      return num;
    },
    // 合计金额
    figureAllAmount() {
      let amount = 0;
      if (this.goodsList !== undefined && this.goodsList !== null) {
        for (const i in this.goodsList) {
          amount += this.goodsList[i].price * this.goodsList[i].num;
        }
      }
      amount = amount.toFixed(2);
      if (amount > 0) {
        // 只要选购了商品,那么买手组,代采组,商家三个条件均变灰.
        this.disableFlag = true;
      } else {
        this.disableFlag = false;
      }
      return amount;
    },
    // 计算实付金额
    figureRealAmount() {
      let amount = 0;
      amount = Number(this.figureAllAmount);
      return amount.toFixed(2);
    },
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.$refs.child.fetchData();
      });
    },
    handleClose() {
      this.$refs.child.curPage = 1;
      this.$refs.child.allData = null;
    },
    getSizeArr(val) {
      for (const key in val.all_item) {
        if (val.co_val == key) {
          this.$set(val, "sizeval_ary", val.all_item[key]);
        }
      }
      // 清空已经上次选择的尺码
      this.$set(val, "si_val", "");
    },
    beforeAvatarUpload(file) {
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > 2) {
        this.$message.error(
          `图片太大了,请缩小到2MB以内再上传,当前图片大小:${size}MB`
        );
        return false;
      }
    },
    previewImage(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    deleteImg1(v) {
      if (this.images1.indexOf(v) >= 0) {
        this.images1.splice(this.images1.indexOf(v), 1);
      }
    },
    deleteImg2(v) {
      if (this.images2.indexOf(v) >= 0) {
        this.images2.splice(this.images2.indexOf(v), 1);
      }
    },
    fetchData() {
      if (this.$route.params.id) {
        const url = "/erp/WcgOrder/getOrderInfo";
        const { id } = this.$route.params;
        if (!parseInt(id) || id <= 0) {
          // 创建计划代采单时,没有订单内容.
          return;
        }
        const args = {
          woid: this.$route.params.id,
        };
        this.$http.post(url, args).then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            let tempGoodsList = [];
            tempGoodsList = res.data.data.info.goodsList;
            // 组装渲染下拉控件数组
            tempGoodsList.map((v, k) => {
              tempGoodsList[k].index = k;
              // 更改行唯一计数器
              this.index_num = k;
              const url = "/erp/Common/selectSPUGoodsLib";
              tempGoodsList[k].colval_ary = [];
              this.$http
                .post(url, {
                  goods_no: tempGoodsList[k].goods_no,
                })
                .then((res) => {
                  if (res.data.code !== 200) {
                    this.$message.error(res.data.msg);
                  } else {
                    const attrdata = res.data.data.data[0].all_item;
                    const temp = [];
                    for (const i in attrdata) {
                      temp.push({ key: i, label: i });
                    }
                    tempGoodsList[k].all_item = attrdata;
                    tempGoodsList[k].colval_ary = temp;
                  }
                });
            });
            // 必须准备好下一次的index_num
            this.index_num++;
            this.goodsList = tempGoodsList;
            this.orderData = res.data.data.info;
            let tmp_cg_type = this.orderData.cg_type.toString();
            if (tmp_cg_type == "4") {
              // 先货后款计划外未垫付代采单,在页面上表现为计划外未垫付代采单选项
              tmp_cg_type = "1";
            }
            this.form.cg_type = tmp_cg_type;
            this.form.supplyName = this.orderData.supply_name;
            // 代采
            this.form.purchaseGroup = this.orderData.pgname;
            // 买手
            this.form.pickerGroup = tempGoodsList[0].pg_name;

            this.form.prepay_people = this.orderData.prepay_people;
            this.note = this.orderData.note;

            this.images1 = this.orderData.docs;
            if (this.orderData.pay_docs.length > 0) {
              this.images2 = this.orderData.pay_docs;
            }
          }
        });
      } else {
      }
    },
    querySearchSupplyname(queryString, cb) {
      let results = [];
      if (queryString) {
        const url = "/erp/Common/selectSupply";
        const data = {
          supply_name: queryString,
        };
        this.$http.post(url, data).then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            for (let i = 0; i < res.data.data.length; i++) {
              res.data.data[i].value = res.data.data[i].supply_name;
            }
            results = res.data.data;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              cb(results);
            }, 300);
          }
        });
      } else {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 300);
      }
    },
    querySearchPurchasegroup(queryString, cb) {
      let results = [];
      if (queryString) {
        const url = "/erp/Common/selectPgid";
        const data = {
          pgname: queryString,
          is_use: 1,
        };
        this.$http.post(url, data).then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            for (let i = 0; i < res.data.data.length; i++) {
              res.data.data[i].value = res.data.data[i].pgname;
            }
            results = res.data.data;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              cb(results);
            }, 300);
          }
        });
      } else {
        setTimeout(() => {
          cb(results);
        }, 300);
      }
    },
    querySearchPickergroup(queryString, cb) {
      let results = [];
      if (queryString) {
        const url = "/erp/Common/selectPickerid";
        const data = {
          pickername: queryString,
        };
        this.$http.post(url, data).then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            for (let i = 0; i < res.data.data.length; i++) {
              res.data.data[i].value = res.data.data[i].pg_name;
            }
            results = res.data.data;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              cb(results);
            }, 300);
          }
        });
      } else {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 300);
      }
    },
    uploadSuccess1(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        const img = `${this.origin}/${res.data.files[0]}`;
        if (this.images1.indexOf(img) < 0) {
          this.images1.push(img);
        }
      }
    },
    uploadSuccess2(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        const img = `${this.origin}/${res.data.files[0]}`;
        if (this.images2.indexOf(img) < 0) {
          this.images2.push(img);
        }
      }
    },
    handleRemove(file, fileList) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    selectGoods() {
      if (!this.supply_id) {
        return this.$message.error("请选择商家");
      }
      this.dialogTableVisible = true;
    },
    addGoods(rowData) {
      // 不需要去查询,直接按照行数据复制一行出来即可
      const arr = [
        {
          goods_no: rowData.goods_no,
          goods_name: rowData.goods_name,
          goods_kh: rowData.goods_kh,
          pg_name: rowData.pg_name,
          brand_name: rowData.brand_name,
          price: rowData.market_price, // 代采单价格
          market_price: rowData.market_price, // 商品库价格
          num: 1,
          sum_price: rowData.market_price,
          si_val: "",
          co_val: "",
          goods_img: rowData.goods_img,
          all_item: rowData.all_item,
          colval_ary: rowData.colval_ary,
        },
      ];
      this.addGoodsRow(arr);
    },
    addGoodsRow(arr) {
      let data = null;
      for (const i in arr) {
        data = arr[i];
      }
      // 新增一行数据行 orderData.goodsList
      const newRow = {
        goods_no: data.goods_no,
        goods_name: data.goods_name,
        goods_kh: data.goods_kh,
        pg_name: data.pg_name,
        brand_name: data.brand_name,
        price: data.market_price, // 代采单价格
        market_price: data.market_price, // 商品库价格
        num: 1,
        sum_price: data.market_price,
        si_val: "",
        co_val: "",
        goods_img: data.goods_img,
        all_item: data.all_item,
        colval_ary: data.colval_ary,
        index: this.index_num,
      };
      if (this.goodsList.length > 0) {
        // 第一次选择商品的时候不用排序
        const tempGoodsList = [];
        let newId = -1;
        // 第一步,找出同款产品最后加入的键值
        for (const key in this.goodsList) {
          if (this.goodsList[key].goods_no == newRow.goods_no) {
            newId = key;
          }
        }
        if (newId < 0) {
          // 没有选过的商品,直接添加在最后面
          this.goodsList.push(newRow);
        } else {
          // 第二步,往键值后面增加一行新数据,然后键值之后的数据键值全部加一,相当于重新赋予键值
          for (const key2 in this.goodsList) {
            if (key2 == newId) {
              tempGoodsList.push(this.goodsList[key2]);
              tempGoodsList.push(newRow);
            } else {
              tempGoodsList.push(this.goodsList[key2]);
            }
          }
          this.goodsList = tempGoodsList;
        }
      } else {
        this.goodsList.push(newRow);
      }
      this.index_num++;
    },

    delGoods(row) {
      for (let i = 0; i < this.goodsList.length; i++) {
        if (this.goodsList[i].index == row.index) {
          this.goodsList.splice(i, 1);
        }
      }
    },
    // 添加从子容器选择的商品列表
    addSelectGoods(data) {
      for (const i in data) {
        this.addGoodsRow([data[i]]);
        this.dialogTableVisible = false;
      }
    },
    digclose(e) {
      this.dialogTableVisible = false;
    },
    submit() {
      // 检查是否有颜色或尺码还没选择
      for (const i in this.goodsList) {
        if (this.goodsList[i].co_val === "") {
          this.$message.error(`商品${this.goodsList[i].goods_name} 颜色未选择`);
          return;
        }
        if (this.goodsList[i].si_val === "") {
          this.$message.error(`商品${this.goodsList[i].goods_name} 尺码未选择`);
          return;
        }
      }
      const url = "/erp/WcgOrder/saveUnplannOrder";
      const tempGoodsList = [];
      for (const k in this.goodsList) {
        const temp = {
          goods_no: this.goodsList[k].goods_no,
          goods_name: this.goodsList[k].goods_name,
          co_val: this.goodsList[k].co_val,
          si_val: this.goodsList[k].si_val,
          price: this.goodsList[k].price,
          num: this.goodsList[k].num,
        };
        tempGoodsList.push(temp);
      }
      const params = {
        supply_id: this.supply_id,
        woid: this.$route.params.id,
        purchaseGroup: this.form.purchaseGroup,
        supply_name: this.form.supplyName,
        cg_type: this.form.cg_type,
        prepay_people: this.form.prepay_people,
        docs_ary: this.images1,
        pay_ary: this.images2,
        goods_ary: tempGoodsList,
        note: this.note,
      };

      this.loading = true;
      this.$http.post(url, params).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          this.loading = false;
        } else {
          this.loading = false;
          this.$notify({
            title: "操作成功",
            message: "",
            type: "success",
          });
          if (fromPath == "purchaseorderlist2") {
            this.$router.push(`/home/purchasing/purchaseorderlist2`);
          } else {
            this.$router.push(`/home/purchasing/purchaseorderlist`);
          }
        }
      });
    },
    fetchSupply(e) {
      if (typeof e === "string" && e.length > 2) {
        this.$http
          .post("/erp/Common/selectSupply", { supply_name: e })
          .then((res) => {
            if (res.data.code != 200) {
              return this.$message.error(res.data.msg);
            }
            this.supplyOption = res.data.data;
          });
      }
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.card-title {
  background: #f3f3f3;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
}

.upload-demo {
  display: inline-block;
  vertical-align: middle;
}

.el-upload--text {
  width: 100%;
}

.el-upload-list__item {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseOrderEdit.vue